// Font loader for CJK (Chinese/Japanese/Korean) support in jsPDF
import type jsPDF from 'jspdf';

// Use CDN that provides full TTF file for Noto Sans SC
const NOTO_SANS_SC_URL = 'https://cdn.jsdelivr.net/fontsource/fonts/noto-sans-sc@latest/chinese-simplified-400-normal.ttf';

let fontLoaded = false;
let fontLoadPromise: Promise<ArrayBuffer> | null = null;

// Check if text contains CJK characters
export const containsCJK = (text: string): boolean => {
  // CJK Unified Ideographs and related ranges
  const cjkRegex = /[\u4E00-\u9FFF\u3400-\u4DBF\u3000-\u303F\uFF00-\uFFEF\u3040-\u309F\u30A0-\u30FF]/;
  return cjkRegex.test(text);
};

// Load and register Noto Sans SC font
export const loadCJKFont = async (doc: jsPDF): Promise<void> => {
  if (fontLoaded) {
    doc.setFont('NotoSansSC', 'normal');
    return;
  }

  if (!fontLoadPromise) {
    fontLoadPromise = fetch(NOTO_SANS_SC_URL).then(res => res.arrayBuffer());
  }

  try {
    const arrayBuffer = await fontLoadPromise;

    // Convert to base64
    const base64 = btoa(
      new Uint8Array(arrayBuffer).reduce(
        (data, byte) => data + String.fromCharCode(byte),
        ''
      )
    );

    // Register font with jsPDF
    doc.addFileToVFS('NotoSansSC-Regular.ttf', base64);
    doc.addFont('NotoSansSC-Regular.ttf', 'NotoSansSC', 'normal');

    fontLoaded = true;
    doc.setFont('NotoSansSC', 'normal');
  } catch (error) {
    console.error('Failed to load CJK font:', error);
    throw error;
  }
};
